'use client';

import React, { Component } from 'react';

import './style.sass';
import Title from '../reusable-components/layouts-components__otp-bank/title';
import {
    listBottom,
    listGraphic,
    listRecommendations,
    listResults,
    listResultsStatisticDetail,
    listResultsStatisticMetrics,
    listStages,
    listStagesAudit,
    listStrategy,
} from './constants';
import Target from '../reusable-components/layouts-components__otp-bank/target';
import LayoutPage from '../reusable-components/layouts-components__otp-bank/layout-page';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import Team from '../reusable-components/layouts-components__otp-bank/team';
import Stages from '../reusable-components/layouts-components__otp-bank/stages';
import Recommendations from '../reusable-components/layouts-components__otp-bank/recommendations';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import Review from '../reusable-components/layouts-components__otp-bank/review';
import Results from '../reusable-components/layouts-components__otp-bank/results';
import Graphic from '../reusable-components/layouts-components__otp-bank/graphic';
import Strategy from '../reusable-components/layouts-components__otp-bank/strategy';
import Dynamics from '../reusable-components/layouts-components__otp-bank/dynamics';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import CommonNav from '../common-components/common-nav';

const nextProjectGens = {
    marketing: true,
    nextProjectTitle: 'Разработка e‑commerce проекта для бренда Teboil',
    nextProjectImg: '/images/pic/teboil/teboil.jpg',
    nextProjectLink: '/cases/development/teboil',
    nextProjectLinkTitle: 'Разработка',
    nextProjectText:
        'В этом кейсе расскажем, как наша команда в кратчайшие сроки, всего за 4 месяца, разработала и выпустила интернет-магазин для бренда Teboil, связав его общим дизайном с основным сайтом бренда и интегрировав с несколькими внешними системами.',
};

class OtpBank extends Component {
    render() {
        return (
            <section>
                <CommonNav
                    stepOne="Главная"
                    stepTwo="Кейсы"
                    stepThree="Маркетинг"
                    link1={'/'}
                    link2={'/cases'}
                    link3={true}
                />
                <Title listBottom={listBottom} />
                <Target />
                <LayoutPage />
                <Stages listStages={listStages} listStagesAudit={listStagesAudit} />
                <Graphic listGraphic={listGraphic} />
                <Strategy listStrategy={listStrategy} />
                <Dynamics />
                <Results
                    listResults={listResults}
                    listResultsStatisticMetrics={listResultsStatisticMetrics}
                    listResultsStatisticDetail={listResultsStatisticDetail}
                />
                <Team />
                <Recommendations listRecommendations={listRecommendations} />

                <Review />
                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                <NextProject NextProject={nextProjectGens} />
            </section>
        );
    }
}
export default OtpBank;
